import React from 'react';
import {
  PlusIcon,
  BookOpenIcon,
  Square3Stack3DIcon,
  ExclamationTriangleIcon,
  ArrowRightIcon,
} from '@heroicons/react/24/outline';
import ButtonComponent from '../customButton';
import { TEST_GROUP_EMPTY_CONTENT } from './testGroupEmptyScreen.constants';
import styles from '../../styles/testGroupLibrary/testGroupEmptyScreen.module.scss';

const TestGroupEmptyScreen = ({
  onCreateTestGroup,
  onHowItWorks,
  onGoToTestCases,
}) => {
  const content = TEST_GROUP_EMPTY_CONTENT;
  const isCreateDisabled = typeof onCreateTestGroup !== 'function';
  const isHowItWorksDisabled = typeof onHowItWorks !== 'function';
  const isTestCasesLinkDisabled = typeof onGoToTestCases !== 'function';

  return (
    <div className={styles.scrollWrapper}>
      <div className={styles.container}>
      <div className={styles.iconSection}>
        <Square3Stack3DIcon className={styles.icon} aria-hidden="true" />
      </div>

      <h3 className={styles.title}>{content.title}</h3>
      <p className={styles.description}>{content.description}</p>

      <div className={styles.actionsRow}>
        <ButtonComponent
          ctaText={content.createButtonLabel}
          variant="primary"
          className="white bg-blue600"
          startIcon={<PlusIcon className="icon" />}
          onClick={onCreateTestGroup}
          disabled={isCreateDisabled}
          size="small"
        />
        <ButtonComponent
          ctaText={content.howItWorksButtonLabel}
          variant="outline"
          startIcon={<BookOpenIcon className="icon" />}
          onClick={onHowItWorks}
          disabled={isHowItWorksDisabled}
          size="small"
        />
      </div>

      <div className={styles.howItWorksCard}>
        <p className={styles.howItWorksCardTitle}>{content.howItWorksCardTitle}</p>
        <ol className={styles.stepsList}>
          {content.steps.map((step, index) => (
            <li key={step.title} className={styles.stepItem}>
              <span className={styles.stepNumber}>{index + 1}</span>
              <span className={styles.stepText}>
                <span className={styles.stepTitle}>{step.title}</span>
                {' — '}
                <span className={styles.stepDescription}>{step.description}</span>
              </span>
            </li>
          ))}
        </ol>

        <div className={styles.warningBanner}>
          <div className={styles.warningContent}>
            <ExclamationTriangleIcon className={styles.warningIcon} aria-hidden="true" />
            <p className={styles.warningText}>{content.warningMessage}</p>
          </div>
          <ButtonComponent
            ctaText={content.testCasesLinkLabel}
            variant="primary"
            className={`white bg-blue600 ${styles.testCasesAction}`}
            endIcon={<ArrowRightIcon className="icon" />}
            onClick={onGoToTestCases}
            disabled={isTestCasesLinkDisabled}
            size="small"
          />
        </div>
      </div>
      </div>
    </div>
  );
};

export default TestGroupEmptyScreen;
